import { FormattedMessage, useIntl } from "react-intl";
import styles from "./MyCart.module.scss";
import { useMyCartLoaderData } from "./myCartLoader.ts";
import EmptyCart from "./EmptyCart.tsx";
import RetailerSegment from "./RetailerSegment.tsx";
import DefaultTemplate from "routes/home/layout/content-templates/default/DefaultTemplate.tsx";

const maxWidth = 1238;

export default function MyCart() {
  const groupedCheckout = useMyCartLoaderData();
  const intl = useIntl();
  const cost = intl.formatNumber(Number(groupedCheckout.totalPrice) ?? 0, {
    style: "currency",
    currency: "USD",
  });
  const allCheckouts = [
    groupedCheckout.epos,
    groupedCheckout.preferredRetailers,
    groupedCheckout.retailers,
  ].flat();
  const allItems = allCheckouts.flatMap((checkout) => checkout.items);

  return (
    <DefaultTemplate
      title={intl.formatMessage({ defaultMessage: "My Cart" })}
      headerConfig={{
        backFallbackLocation: "/my-courses",
        allowImpersonationBanner: true,
        maxWidth,
      }}
    >
      <div className={styles.cartWidth} style={{ maxWidth }}>
        <h1
          className={
            allItems.length === 0 ? styles.myCartTitleEmpty : undefined
          }
        >
          <FormattedMessage defaultMessage="My Cart" />
        </h1>
        {allItems.length === 0 ? (
          <EmptyCart />
        ) : (
          <>
            {allCheckouts.map((checkout) => (
              <RetailerSegment
                checkout={checkout}
                key={checkout.retailerName}
                className={styles.retailer}
              />
            ))}
            <div className={styles.footer}>
              <FormattedMessage
                defaultMessage="My Cart Total ({total, plural, =1 {1 item} other {# items}}): {cost}"
                values={{
                  total: allItems.length,
                  cost,
                }}
              />
            </div>
          </>
        )}
      </div>
    </DefaultTemplate>
  );
}
